let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h4k4y"), load("4waaI"), load("h7oxu"), load("1L8Re"), load("drB6v"), load("6aruy")]).then(() => parcelRequire('9VKkC'));